export const stripHTML = (html: string) => {
    // Menggunakan ekspresi reguler untuk mencari tag HTML dan menggantinya dengan string kosong
    return html.replace(/<\/?[^>]+(>|$)/g, "");
}